<template>
  <div>
    <final-grade-select-reviewers-checkboxes :reviewers="reviewers"
                                             @change="checkedReviewers = $event"/>

    <final-grade-select-reviewers-table :reviewers="checkedReviewers"
                                        v-bind="$props"
                                        @reviews="reviews=$event"
                                        @setup-proposal="emitSetupProposal($event)"
                                        @reviewers-proposals-counter="loadReviewersProposalsCounter"/>

    <b-btn v-if="proposals.length > 0"
           class="stick-bottom right"
           variant="info"
           @click="submitReviews">
      SUBMIT
    </b-btn>

  </div>
</template>

<script>
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import FinalGradeSelectReviewersTable from '@/components/evaluation/final-grade/FinalGradeSelectReviewersTable';
  import FinalGradeSelectReviewersCheckboxes
    from '@/components/evaluation/final-grade/FinalGradeSelectReviewersCheckboxes';

  export default {
    name: 'FinalGradeSelectReviewers',
    components: {
      FinalGradeSelectReviewersCheckboxes,
      FinalGradeSelectReviewersTable,
    },
    props: {
      proposals: {
        type: Array,
        default: () => [],
      },
      // necessary for proposal and calls filter feature
      selectedCall: {
        type: String,
        required: true,
      },
      parentId: {
        type: Number,
        required: true,
      },
      // end
    },
    data() {
      return {
        reviews: {},
        reviewers: [],
        checkedReviewers: [],
        reviewersProposalsCounter: [],
        reviewsUrl: '',
        errors: {
          loadData: {
            type: 'error',
            title: 'Could not retrieve reviewers. Please contact User Office',
          },
          submitReviews: {
            okMsg: {
              type: 'success',
              title: 'Submitted successfully!',
            },
            errorMsg: {
              type: 'error',
              title: 'Could not submit',
            },
          },
        },
      };
    },
    mixins: [infrastructureMixin],
    methods: {
      loadReviewersProposalsCounter(reviewersProposalsCounter) {
        this.reviewersProposalsCounter = reviewersProposalsCounter;
      },
      processReviewersProposalsCounter() {
        if (!this.reviewersProposalsCounter.length && !this.reviewers.length) return;

        this.reviewers = this.reviewers.map((reviewer) => {
          const reviewerId = this.getId(reviewer);

          const counterValue = Object.values(
            this.reviewersProposalsCounter,
          ).reduce((acc, counterObj) => (
            counterObj[reviewerId] !== undefined ? counterObj[reviewerId] : acc), null);

          return { ...reviewer, reviewerProposalCounter: counterValue };
        });
      },
      async loadData() {
        const response = await this.axios.get(this.reviewsUrl);
        if (response.data) {
          this.reviewers = response.data;
        } else {
          this.$notify(this.errors.loadData);
        }
      },
      async submitReviews() {
        const response = await this.axios.put(`/documents/reviews/${this.infrastructure}`, this.reviews);
        if (response.data) {
          this.$notify(this.errors.submitReviews.okMsg);
        } else {
          this.$notify(this.errors.submitReviews.errorMsg);
        }
      },
    },
    async created() {
      const helpers = await this.getEvaluationDashboardProperties(this.infrastructure, 'FinalGrade');
      this.reviewsUrl = helpers.getSingleField('reviewsUrl');
      await this.loadData();
    },
    watch: {
      reviewersProposalsCounter() {
        this.processReviewersProposalsCounter();
      },
    },
  };
</script>

<style scoped>
  .stick-bottom {
    position: sticky;
    bottom: 8px;
    margin-top: -3.5rem;
    z-index: 2;
  }

  .right {
    right: 8px;
  }
</style>
